import { defineStore } from 'pinia'
import { IStore } from '@/system-modules/update/v1/core/interface/IStore'

export default defineStore('systemUpdateStoreV1', {
  state: (): IStore => {
    return {
      available: false,
      updating: false,
    }
  },
})
